import { PoolConfig, QuoteToken, PoolCategory } from './types'

const pools: PoolConfig[] = [
  {
    sousId: 0,
    tokenName: 'shifty mooncake',
    image: 'shifty',
    stakingTokenName: QuoteToken.MCBNB,
    stakingTokenAddress: '0x911494652f27e33d76f966423fa36cde0aee723d',
    contractAddress: {
      97: '0x7e6eef571dcb8ca9cae79bfcd0674a7dddce1328',
      56: '0x7e6eef571dcb8ca9cae79bfcd0674a7dddce1328',
    },
    poolCategory: PoolCategory.CORE,
    projectLink: 'https://pancakeswap.finance/',
    harvest: true,
    tokenPerBlock: '10',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
]

export default pools
